// src/actions/documentSubmissionActions.js
// Redux actions for the doc-intake pipeline: .md document upload → Agent 1 → Agent 3 + Agent 4

export const REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL =
  "REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL";
export const REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_SUCCESS =
  "REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_SUCCESS";
export const REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_FAILURE =
  "REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_FAILURE";

export const UPLOAD_DOCUMENT_FILE = "UPLOAD_DOCUMENT_FILE";
export const UPLOAD_DOCUMENT_FILE_SUCCESS = "UPLOAD_DOCUMENT_FILE_SUCCESS";
export const UPLOAD_DOCUMENT_FILE_FAILURE = "UPLOAD_DOCUMENT_FILE_FAILURE";
export const UPLOAD_DOCUMENT_FILE_PROGRESS = "UPLOAD_DOCUMENT_FILE_PROGRESS";

export const RESET_DOCUMENT_SUBMISSION_STATE = "RESET_DOCUMENT_SUBMISSION_STATE";

export const requestDocumentSubmissionPresignedUrl = (payload) => ({
  type: REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL,
  payload,
});

export const requestDocumentSubmissionPresignedUrlSuccess = (presignedUrl) => ({
  type: REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_SUCCESS,
  payload: presignedUrl,
});

export const requestDocumentSubmissionPresignedUrlFailure = (error) => ({
  type: REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_FAILURE,
  payload: error,
});

export const uploadDocumentFile = (file, presignedUrl, fileName) => ({
  type: UPLOAD_DOCUMENT_FILE,
  payload: { file, presignedUrl, fileName },
});

export const uploadDocumentFileSuccess = () => ({
  type: UPLOAD_DOCUMENT_FILE_SUCCESS,
});

export const uploadDocumentFileFailure = (error) => ({
  type: UPLOAD_DOCUMENT_FILE_FAILURE,
  payload: error,
});

export const uploadDocumentFileProgress = (progress) => ({
  type: UPLOAD_DOCUMENT_FILE_PROGRESS,
  payload: progress,
});

export const resetDocumentSubmissionState = () => ({
  type: RESET_DOCUMENT_SUBMISSION_STATE,
});
